angular.module('shared').factory('SMSesSentThisMonthService', ["$rootScope", "$stateParams", "$http", function($rootScope, $stateParams, $http) {
  var count, currentGymId, loadingPromise;
  count = 0;
  loadingPromise = null;
  currentGymId = null;
  $rootScope.$on('$stateChangeStart', function() {
    return loadingPromise = null;
  });
  return {
    getCount: function() {
      return count;
    },
    load: function() {
      var gymId, ref, url;
      gymId = ((ref = $rootScope.gym) != null ? ref.id : void 0) || $stateParams.gymId;
      if (currentGymId !== gymId) {
        loadingPromise = null;
        currentGymId = gymId;
      }
      if (loadingPromise) {
        return loadingPromise;
      }
      url = `/gyms/${gymId}/sent_messages/smses_parts_this_month`;
      loadingPromise = $http.get(url).then(function(response) {
        return count = response.data.sms_parts_sent_this_month;
      });
      return loadingPromise;
    }
  };
}]);
